module.exports = {
	"Search the video": "搜索视频",
	"Explore": "探索",
	"Print": "打印",
	"Download": "下载",
	"Share": "分享",
	"Settings": "设置",
	"Language": "语言",
	"Interface Language": "界面语言",
	"Transcript / Captions Language": "副本/字幕语言",
	"Transcript Language": "副本语言",
	"Captions Language": "字幕语言",
	"Show Transcript": "显示副本",
	"Show Captions": "显示字幕",
	"Show Heatmap": "显示热图",
	"Show Speakers in Transcript": "在副本中显示说话者",
	"Keyword": "关键词",
	"Keywords": "关键字",
	"Topic": "主题",
	"Topics": "主题",
	"Speaker": "说话者",
	"Speakers": "说话者",
	"Transcript": "副本",
	"Previous": "上一个",
	"Next": "下一个",
	"Clear": "清除",
	"No results found": "未找到结果",
	"try another search or explore": "请尝试其它搜索或探索",
	"Share Search": "分享搜索",
	"Share Time": "分享时间",
	"There is no transcript available in the selected language.": "无所选语言的可用副本。",
	"Show {{count}} more": "显示{{count}}个",
	"Show {{count}} more_plural": "显示{{count}}个"
};


//////////////////
// WEBPACK FOOTER
// ./locale/zh-cmn.json
// module id = ./locale/zh-cmn.json
// module chunks = 0 1